import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	state: {
		onayBekleyenSiparisler: 0,
		modulList : [],
		tabList : [],
		activeTabs: '',
		updateKodu: '',
		updateLink: '',
		navVisible: true,
		dilDurum: true,
		tabsClose: true,
		sayfaList : ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
		zilDurum: false,
		zilAcildiMi: false,

		layout: {
			navPos: 'left', //top, bottom, left, right, false
			toolbar: 'top', //top, bottom, false
			footer: true, //above, below, false
			boxed: false, //true, false
			roundedCorners: false, //true, false
			viewAnimation: 'fade-top' // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
		},
		splashScreen: true,
		logged: true
	},
	mutations: {
		changeZilAcildiMi(state, value){
			state.zilAcildiMi = value;
		},
		changeZilDurum(state, value){
			state.zilDurum = value;
		},
		changeSiparisListeUzunluk(state, value){
			state.onayBekleyenSiparisler = value
		},
		changeModulList: (state, value) => {
			state.modulList = value
		},
		changeTabList: (state, value) => {
			state.tabList = value
		},
		changeActiveTabs: (state, value) => {
			state.activeTabs = value
		},
		changeUpdateKodu: (state, value) => {
			state.updateKodu = value
		},
		changeUpdateLink: (state, value) => {
			state.updateLink = value
		},
		changeNavVisible: (state, value) => {
			state.navVisible = value
		},
		changeSayfaList: (state, value) => {
			state.sayfaList = value
		},
		changeTabsClose: (state, value) => {
			state.tabsClose = value
		},



		setLayout(state, payload) {
			if(payload && payload.navPos !== undefined)
				state.layout.navPos = 'top'

			if(payload && payload.toolbar !== undefined)
				state.layout.toolbar = payload.toolbar

			if(payload && payload.footer !== undefined)
				state.layout.footer = payload.footer
		
			if(payload && payload.boxed !== undefined)
				state.layout.boxed = payload.boxed

			if(payload && payload.roundedCorners !== undefined)
				state.layout.roundedCorners = payload.roundedCorners

			if(payload && payload.viewAnimation !== undefined)
				state.layout.viewAnimation = payload.viewAnimation
		},
		setLogin(state, payload) {
			state.logged = true
		},
		setLogout(state, payload) {
			state.layout.navPos = null
			state.layout.toolbar = null
			state.logged = false
		},
		setSplashScreen(state, payload) {
			state.splashScreen = payload
		}
	},
	actions: {

	},
	getters: {
		getZilAcildiMi(state, value){
			return state.zilAcildiMi;
		},
		getZilDurum(state, getters){
			return state.zilDurum
		},
		getOnayBekleyenListUzunluk(state, getters){
			return state.onayBekleyenSiparisler
		},
		getUpdateKodu(state, getters){
			return state.updateKodu
		},
		getUpdateLink(state, getters){
			return state.updateLink
		},
		getTabList(state, getters){
			return state.tabList
		},

		layout(state, getters) {
			return state.layout
		},
		navPos(state, getters) {
			return state.layout.navPos
		},
		toolbar(state, getters) {
			return state.layout.toolbar
		},
		footer(state, getters) {
			return state.layout.footer
		},
		boxed(state, getters) {
			return state.layout.boxed
		},
		roundedCorners(state, getters) {
			return state.layout.roundedCorners
		},
		viewAnimation(state, getters) {
			return state.layout.viewAnimation
		},
		isLogged(state, getters) {
			return state.logged
		},
		splashScreen(state, getters) {
			return state.splashScreen
		}
	},
	plugins: [createPersistedState({paths: ['layout']})],
	strict: debug
})
